import { render } from "./Dashboard.vue?vue&type=template&id=65d7d4a3&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=65d7d4a3&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=65d7d4a3&lang=css"
script.render = render
script.__scopeId = "data-v-65d7d4a3"

export default script